<script>
export default {
    name : "LoginReportTracker"
}
</script>

<template>
    <div style="height:95vh">             
        <!-- <p class="has-text-weight-semibold has-text-white"
            style="margin:0.5rem;">7th Report Tracker</p> -->
        <div class="announcement-holder">
            <iframe 
                frameborder="0" onmousewheel="" width="100%" height="533" 
                style="background: transparent; border: 1px solid #ccc;height:80vh;"
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vR9WI6pdLA6O5yx6HWaC7pgDKRi9mfXsthP9pxXYrEWx6cnSssY61axHW4OkY5ywn1YfjvH9GSwyxof/pubhtml?widget=true&amp;headers=false">
            </iframe>
        </div>
    </div>
</template>

<style scoped>
.announcement-holder {
    margin-bottom:1rem;
    max-height: 82vh;
    min-height: 80vh;
    overflow-y:scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginReportTracker.vue